/* eslint-env browser */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AUToastComponent from '@aarhus-university/au-lib-react-components/src/components/delphinus/AUToastComponent';
import AUReceiptComponent from '@aarhus-university/au-lib-react-components/src/components/form/AUReceiptComponent';
import { passwordLabels } from '@aarhus-university/au-lib-react-components/src/lib/i18n';
import {
  renderValidation,
  validateForm,
  emailRegex,
  studentRegistrationNumberRegex,
  auIdRegex,
} from '@aarhus-university/au-lib-react-components/src/lib/validation';
import MailSentReceiptComponent from './MailSentReceiptComponent';
import actionCreators from '../actions/password';

const UsernameForgotComponent = ({
  password: { saving, saved },
  messages,
  sendMail,
  dismissMessages,
  onSendAction,
}) => {
  const [privateMailAddress, setPrivateMailAddress] = useState('');
  const [privateMailValidationMessages, setPrivateMailValidationMessages] = useState([]);
  const [isPrivateMailValid, setIsPrivateMailValid] = useState(false);

  const validationRules = [{
    message: passwordLabels[window.appLang].validInput,
    rule: (fieldValue) => {
      const trimmed = fieldValue.trim();
      return trimmed.match(emailRegex)
        || trimmed.match(studentRegistrationNumberRegex)
        || trimmed.match(auIdRegex);
    },
  }];

  useEffect(() => {
    dismissMessages();
  }, []);

  const renderMessages = messages.map(
    (message) => (
      <AUToastComponent
        key={message.message}
        message={message}
        dismiss={dismissMessages}
      />
    ),
  );

  const validatePrivateMail = (value, alert = true) => {
    const [valid, vMessages] = validateForm(window.appLang, value, validationRules);
    setPrivateMailAddress(value);
    setPrivateMailValidationMessages(alert ? vMessages : []);
    setIsPrivateMailValid(valid);
  };

  const submit = (e) => {
    e.preventDefault();
    validatePrivateMail(privateMailAddress, !isPrivateMailValid);
    if (isPrivateMailValid) {
      sendMail({
        privateMailAddress,
      }, onSendAction);
    }
  };

  if (saved) {
    return [
      <div key="receipt" className="page__content__block">
        <AUReceiptComponent
          receiptText={passwordLabels[window.appLang].mailReceiptHeader2}
          showGoTo={false}
        />
      </div>,
      <MailSentReceiptComponent
        key="help"
        mailReceiptHelp={passwordLabels[window.appLang].mailReceiptHelp3}
        goBackLink={`/${window.appLang}/user/forgot`}
      />,
    ];
  }

  if (saved) {
    return (
      <div className="page__content__block">
        <AUReceiptComponent
          receiptText={passwordLabels[window.appLang].mailReceiptHeader}
          helpText={<p>{passwordLabels[window.appLang].mailReceiptHelp}</p>}
          buttons={[
            {
              gotoLink: `/${window.appLang}/user/forgot`,
              gotoText: passwordLabels[window.appLang].goBack,
            },
          ]}
        />
      </div>
    );
  }

  let privateMailValidationClassName = '';
  if (!isPrivateMailValid && privateMailValidationMessages.length) {
    privateMailValidationClassName = ' form-info--error';
  } else if (isPrivateMailValid) {
    privateMailValidationClassName = ' form-info--confirmed';
  }

  return [
    <div key="form" className="page__content__block">
      <h1>{passwordLabels[window.appLang].forgotUsername}</h1>
      <p>{passwordLabels[window.appLang].forgotUsernameParagraph}</p>
      <form
        key="form"
        className="form"
        noValidate="novalidate"
        onSubmit={(e) => {
          submit(e);
        }}
      >
        <div className={`form__field${privateMailValidationClassName}`}>
          <label key="label" htmlFor="mail-private">
            {passwordLabels[window.appLang].privateMail}
            <div className="form-info__hint">
              {passwordLabels[window.appLang].privateMailHint2}
            </div>
            {renderValidation(privateMailValidationMessages)}
          </label>
          <input
            type="text"
            id="mail-private"
            value={privateMailAddress || ''}
            onChange={(e) => {
              validatePrivateMail(e.target.value.trim(), privateMailValidationMessages.length);
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                validatePrivateMail(e.target.value.trim());
              }
            }}
            disabled={saving}
          />
        </div>
        <div className="submit">
          <div className={`${saving ? 'submit-input-wrapper--processing' : ''}`}>
            <input
              className="button"
              type="submit"
              value={passwordLabels[window.appLang].sendBtnUsername}
              disabled={saving}
            />
          </div>
        </div>
      </form>
    </div>,
    ReactDOM.createPortal(
      renderMessages,
      document.querySelector('body'),
      'messages',
    ),
  ];
};

UsernameForgotComponent.defaultProps = {
  onSendAction: async (data, callback) => {
    const url = '/V1/User/RequireUsernameRecovery';
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    let json = null;
    if (!response.ok) {
      json = await response.json();
    }
    callback(response.ok, response.status, json);
  },
};

UsernameForgotComponent.propTypes = {
  password: PropTypes.shape({}).isRequired,
  messages: PropTypes.shape({}).isRequired,
  sendMail: PropTypes.func.isRequired,
  dismissMessages: PropTypes.func.isRequired,
  onSendAction: PropTypes.func,
};

UsernameForgotComponent.displayName = 'UsernameForgotComponent';

export default connect(
  (state) => state.password,
  (dispatch) => bindActionCreators(actionCreators, dispatch),
)(UsernameForgotComponent);
